export default class ApiVersionConstants {
  public static V_2 = "api/v2";
}
